import { Button } from '@/src/components/Commons/Button';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { CLOSE } from "@/src/lib/SmartDB/Commons/Constants/images";
import styles from './ModalGetApiToken.module.scss';
import { useModalGetApiToken } from './useModalGetApiToken';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    height: 300,
    padding: '15px',
    borderRadius: '15px',
    bgcolor: `#e2a7a7`,
    backdropFilter: 'blur(12px)',
};

export const ModalGetApiToken = () => {
    //--------------------------------------
    const { isRefreshing, isLoadedDetails, isLoadingDetails, isReady, apiToken, isOpen, handleOpen, handleClose, txComponentProps } = useModalGetApiToken();
    //--------------------------------------
    return (
        <>
            {isReady ? (
                <Button mode="outline-no-arrow" size="small" width={120} onClick={handleOpen}>
                    Get Api Token
                </Button>
            ) : null}
            {isOpen === true ? (
                <div className={styles.modal}>
                    <div className={`${styles.main}`}>
                        <div className={styles.popUp}>
                            <>
                                <header className={styles.headerModal}>
                                    <h2 className={styles.titleModal}>Get Api Token</h2>
                                    <svg width="45" height="45" className={styles.icon} onClick={handleClose}>
                                        <use href={CLOSE}></use>
                                    </svg>
                                </header>
                                {!isLoadedDetails || isLoadingDetails ? <div className={styles.loadingDiv}>{<LoaderButton />}</div> : <textarea rows={12} cols={100} value={apiToken} readOnly={true} style={{fontSize: "14px"}}></textarea>}
                            </>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
    //--------------------------------------
};
